export default __webpack_public_path__ + "64f01ce4760b205c28adcb27a2737328.svg";